import { Avatar as AntdAvatar, Image } from "antd";
import { useState } from "react";

const Avatar = ({ src, alt, size = 64, shape = "square", fallback }) => {
  const [previewVisible, setPreviewVisible] = useState(false);

  if (!src && !fallback) {
    return null;
  }

  const handleClick = () => {
    setPreviewVisible(true);
  };

  return (
    <>
      <div onClick={handleClick} style={{ cursor: "pointer" }}>
        <AntdAvatar
          shape={shape}
          size={size}
          src={
            src ? (
              <img
                src={src}
                alt={alt || "avatar"}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />
            ) : (
              fallback
            )
          }
        />
        {src && (
          <Image
            src={src}
            alt={alt || "avatar"}
            preview={{
              visible: previewVisible,
              onVisibleChange: (visible) => setPreviewVisible(visible),
            }}
            style={{ display: "none" }}
          />
        )}
      </div>
    </>
  );
};

export default Avatar;
